<template>
  <div>
    <template v-if="useActablStyles">
      <v-app
        style="background: linear-gradient(64.7deg, #FFFFFF 23.24%, #E5EDFB 57.05%, #FEEADD 94.45%)"
      >
        <div class="wrapper">
          <div :class="{ bar: true }" />
          <div
            class="release"
            style="top: 32; right: 180"
          >
            <a
              href="https://profitsword.na1.teamsupport.com/knowledgeBase/25456071"
              target="_blank"
              class="group default-color"
            >
              Release notes
            </a>
          </div>
          <div
            class="actablStylesContainer1"
            :class="{ 'expanded': isResetPasswordAlertVisible }"
          >
            <div class="logo">
              <div style="display: flex; align-items: center; padding-top: 25px">
                <img :src="NewPSLogo">
                <div style="padding-left: 3%; padding-bottom: 3%">
                  <div>
                    <img :src="ProfitswordLogo">
                    <div class="logo-line" />
                  </div>
                  <!-- by actbl -->
                  <div
                    style="
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding-left: 75%;
                  "
                  >
                    <img
                      :src="ByPSLogo"
                      alt="by"
                    >
                    <img
                      :src="ActblPSLogo"
                      alt="actbl"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div />
           
            <div
              class="login-router"
              @click="redirectToLogin"
            >
              <span
                class="material-icons"
                style="font-size: 14px; margin-right: 5px;"
              >arrow_back</span>Back to login
            </div>
            <div style="width: 100%; color: #C7CDD6">
              <hr style="color: #5F6C81; opacity: 0.2;">
            </div>
  
            <div style="color: black; margin-right: auto;">
              <h3>
                {{ translate("label.forgotPassword") }}
              </h3>
            </div>
            <div style="color: black; font-size: 14px; margin-top: -15px;">
              {{ translate("label.forgotPasswordMessage") }}
            </div>
            <div class="reset-item">
              <v-form
                class="form-reset form"
                @keyup.native.enter="resetPassword"
              >
                <div class="input-label">
                  <label>Username</label>
                </div>
                <div class="form-field">
                  <input
                    id="username"
                    v-model="username"
                    prepend-icon="person"
                    type="text"
                    :label="translate('label.username')"
                    :error="!!error"
                    :error-messages="error"
                    outline
                    dense
                    autofocus
                    class="form-input"
                    placeholder="Your Username"
                  >
                </div>
                <div class="input-label">
                  <label>Email</label>
                </div>
                <div class="form-field">
                  <input
                    id="email"
                    v-model="email"
                    type="email"
                    :label="translate('label.email')"
                    :error="!!error"
                    :error-messages="error"
                    outline
                    dense
                    class="form-input"
                    placeholder="Your Email Address"
                    @keyup.enter="resetPassword"
                  >
                </div>
                <div class="errorText">
                  {{ error }}
                </div>
                <div class="form-field">
                  <ps-button
                    id="ResetPasswordButton"
                    style="margin-top: 10px"
                    class="btn"
                    depressed
                    :click="showResetPasswordConfirmation"
                  >
                    {{ translate("label.requestNewPasswordLink") }}
                  </ps-button>
                </div>
              </v-form>
            </div>
          </div>
        </div>
        <div
          v-if="showConfirmation"
          class="confirm-overlay"
        >
          <div
            class="confirm-dialog"
            :class="{ 'expanded': isResetPasswordAlertVisible }"
          >
            <div>
              <div style="display: flex; justify-content: space-between;">
                <span class="confirm-title">Confirmation Required</span>
                <span
                  class="material-icons cancel-icon"
                  @click="closeConfirmation"
                >close</span>
              </div>
              <div class="confirm-text">
                {{ translate("label.confirmResetPassword") }} {{ username }}?
              </div>
            </div>
            <div
              class="reset-item"
              style="margin: 0px; padding: 0px"
            >
              <v-form
                class="form-reset form"
                @keyup.native.enter="resetPassword"
              >
                <ps-alert
                  v-model="isResetPasswordAlertVisible"              
                  text
                  :type="alertType"
                  transition="scale-transition"
                  :message="resetPasswordMessage"
                />
                <div class="form-field btn-group">
                  <button
                    class="cancel-btn"
                    type="button"
                    @click="closeConfirmation"
                  >
                    Cancel
                  </button>
                  <button
                    id="ResetPasswordButton"
                    class="confirm-btn"
                    :class="{ 'disabled-button': !confirmReset }"
                    type="button"
                    depressed
                    :disabled="!confirmReset"
                    @click="resetPassword"
                  >
                    Confirm
                  </button>
                </div>
              </v-form>
            </div>
          </div>
        </div>
      </v-app>
    </template>
    <template v-else>
      <v-app
        style="background: #ebebeb"
      >
        <v-container
          class="fill-height"
        >
          <v-row>
            <v-col
              cols="3"
              align="left"
            >
              <ps-button
                id="ProfitSwordLinkButton"
                class="loginFormLink"
                href="https://profitsword.com"
                target="_blank"
                text
                depressed
                color="#777"
              >
                {{ this.translate('label.poweredByProfitSword') }}
              </ps-button>
            </v-col>
            <v-col cols="6" />
            <v-col
              cols="3"
              align="right"
            >
              <div
                class="socialIcons"
                style="float:right"
              >
                <a
                  target="_blank"
                  href="https://www.facebook.com/profitsword/"
                ><img :src="FbLogo"></a>
                <a
                  target="_blank"
                  href="https://twitter.com/profitsword"
                ><img :src="TwitterLogo"></a>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/profitsword/"
                ><img :src="InLogo"></a>
                <a
                  target="_blank"
                  href="https://www.instagram.com/profitsword/"
                ><img :src="IgLogo"></a>
              </div>
            </v-col>
          </v-row>
          <v-row
            justify="center"
            align="center"
            no-gutters
          >
            <v-col
              cols="7"
              justify="center"
              align="center"
              class="d-flex elevation-5 flex-row justify-center mb-6 reset-card"
              style="background:white; max-width: 680px; min-width: 680px;"
            >
              <v-card
                class="d-flex align-content-center flex-wrap"
                min-width="18em"
                style="box-shadow:none; margin:40px 0 20px 20px;"
              >
                <div class="loginLogo">
                  <img
                    id="clientLogo"
                    :src="logo"
                    width="80%"      
                  >
                </div>
                
                <v-row>
                  <v-col 
                    class="white--text clientName"
                  >
                    {{ psClientName }}
                  </v-col>
                </v-row>
              </v-card>
              <v-card
                v-if="!showLanding"
                class=" align-content-center"
                min-width="18em"
                tile
                style="box-shadow:none; margin:40px 0 20px 20px; border-left:1px solid #d7d7d7"
              >
                <v-toolbar-title>{{ this.translate("label.resetPassword") }}</v-toolbar-title>
                <v-spacer />
                <v-card-text>
                  <v-form :disabled="elementDisabled">
                    <v-text-field
                      v-model="username"
                      prepend-icon="person"
                      :label="this.translate('label.username')"
                      type="text"
                      :disabled="elementDisabled"
                    />
                    <v-text-field
                      v-model="email"
                      prepend-icon="email"
                      :label="this.translate('label.email')"
                      type="email"
                      :disabled="elementDisabled"
                      @keyup.enter="resetPassword"
                    />
                  </v-form>
                  <ps-alert
                    v-model="isResetPasswordAlertVisible"              
                    text
                    :type="alertType"
                    transition="scale-transition"
                    :message="resetPasswordMessage"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    type="submit"
                    :disabled="elementDisabled"
                    @click="resetPassword"
                  >
                    {{ this.translate("label.requestNewPassword") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="3"
              align="left"
            >
              <a href="https://profitsword.na1.teamsupport.com/knowledgeBase/25456071">Latest Release Notes</a>
            </v-col>
            <v-col cols="6" />
            <v-col
              cols="3"
              align="right"
              style="float:right"
            >
              <p
                v-if="version"
                class="version"
              >
                {{ this.translate("label.version") + " " + version }}
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-app>
    </template>
  </div>
</template>



<script>  
import PsLogo from "../assets/logo.png";
import FbLogo from "../assets/social_icons/facebook.svg";
import InLogo from "../assets/social_icons/linked_in.svg";
import TwitterLogo from "../assets/social_icons/twitter.svg";
import IgLogo from "../assets/social_icons/instagram.svg";
import ProfitswordLogo from "../assets/profitsword.svg";
import NewPSLogo from "../assets/ps.svg";
import ByPSLogo from "../assets/by.svg";
import ActblPSLogo from "../assets/actbl.svg";


export default {
    data(){
        return {
            email:"",
            username:"",
            logo: PsLogo,
            FbLogo: FbLogo,
            InLogo: InLogo,
            TwitterLogo: TwitterLogo,
            IgLogo: IgLogo,
            ProfitswordLogo: ProfitswordLogo,
            NewPSLogo: NewPSLogo,
            ByPSLogo: ByPSLogo,
            ActblPSLogo: ActblPSLogo,
            // todo: investigate feasibility.
            redirectUrl:window.location.origin + "/" + "#" + "/" + "SetPassword",  
            elementDisabled: false,
            resetPasswordMessage: "",
            isResetPasswordAlertVisible: null,
            alertType: "",
            useActablStyles: false,
            error: null,
            appUrl: this.$route.query.appUrl,
            showConfirmation: false,
            confirmReset: true
        };
    },
    created() {
        // Reads from url the paramenter of the new design.
        const match = window.location.href.match(/[\?&]useActablStyles=([^&]*)/);
        if (match) {
            const local = decodeURIComponent(match[1].replace(/\+/g, ""));
            this.useActablStyles = local === "Y" ? true : false;
            this.$nextTick(() => {
                // Adjust the html and body class when new design flag is active
                if (this.useActablStyles) {
                    document.documentElement.classList.add("customhtml");
                    document.body.style.background =
            "linear-gradient(64.7deg, #FFFFFF 23.24%, #E5EDFB 57.05%, #FEEADD 94.45%)";
                } else {
                    document.documentElement.classList.remove("customhtml");
                    document.body.removeAttribute("class");
                    document.body.style.background = "";
                }
            });
        }
        let pscg, alertMessage, alertType;
        if (this.$route.params.pscg) {
            pscg = this.$route.params.pscg;
            alertMessage = this.$route.params.alertMessage;
            alertType = this.$route.params.alertType;
        }
        else  if (this.$route.query.pscg) {
            pscg = this.$route.query.pscg;
            alertMessage = this.$route.query.alertMessage;
            alertType = this.$route.query.alertType;
        }
        this.pscg = pscg;
        this.isResetPasswordAlertVisible = alertMessage ? true : this.isResetPasswordAlertVisible;
        this.resetPasswordMessage = alertMessage ? alertMessage : this.resetPasswordMessage;
        this.alertType = alertType ? alertType: this.alertType;
    },
    methods: {
        showResetPasswordConfirmation() {
            this.showConfirmation = true;
        },
        resetPassword(){
            this.confirmReset = false;
            const payload = {
                username: this.username,
                email: this.email,
                redirectUrl: this.redirectUrl,
                pscg: this.pscg ? this.pscg : this.$route.query.pscg,
                appUrl: encodeURIComponent(this.$route.query.appUrl),
                version:this.getVersionFromUrl(), //this.$route.query.page.substring(1, 4)
                useActablStyles: this.useActablStyles ? "Y" : "N",
            };
            this.$store.dispatch("resetPasswordRequest", payload).then(() => {
                this.elementDisabled = true;
                this.isResetPasswordAlertVisible = true;
                this.resetPasswordMessage = this.translate("message.PASSWORD_EMAIL_LINK");
                this.alertType = "success";
            }).catch((error) => {
              
                if (typeof(error.response) == "undefined" || error.response.status === "404") {
                    this.error = "Error contacting authentication server.";
                    this.resetPasswordMessage = "Error contacting authentication server.";
                    this.alertType = "error";
                }
                else { // Error other than a "404" occurred
                    this.alertType = "error";
                    alert(JSON.stringify(error.response));
                    this.error = error.response.data.error_description;
                    this.resetPasswordMessage = this.error;
                    this.isResetPasswordAlertVisible = true;
                }
                return;
            });        
        },
        getVersionFromUrl(){
            var version = window.location.href;
            version = version.substring(0,version.search("#")-1 );
            var n = version.search("/");
            while(n>-1)
            {
                version = version.substring(n+1);
                n = version.search("/");
            }
          

            return version;
        },
        redirectToLogin() {
            window.location.href = this.appUrl;
        },
        closeConfirmation() {
            this.showConfirmation = false;
            this.confirmReset = true;
            this.isResetPasswordAlertVisible = false;
        }
    }

};
</script>

<style lang="scss">
@import "../styles/ResetPassword.scss";
</style>
